import once from 'once';
import { useEffect } from 'react';
const throwErrorOnce = once(isSSR => {
  throw new Error(`Simulated Error: Widget, ${isSSR ? 'SSR' : 'CSR'}`);
});
export const useSimulateError = wfConfig => {
  const {
    simulateError,
    isSSR
  } = wfConfig;
  useEffect(() => {
    if (simulateError) {
      throwErrorOnce(Boolean(isSSR));
    }
  }, [simulateError, isSSR]);
};
//# sourceMappingURL=use-simulate-error.js.map